import { EVisitorIntegrationEnum } from "@/shared/models/enums.type";
import { DateTime } from "luxon";

export class SetCheckedInCustomers {
  constructor(
    public reservationId: number,
    public changeReservationStatusToCheckedIn: boolean,
  ) { }
  payload: CheckedInCustomersOnAccUnitType[] = [];
}

export class CheckedInCustomersOnAccUnitType {
  reservationAccUnitTypeId = 0;
  propertyId = null as number | null;
  propertyName = "";
  accomodationUnitTypeName = "";
  accomodationUnitId = null as number | null;
  accomodationUnitName = "";
  reservationAccUnitTypeAllocated = 0;
  reservationAccUnitTypeAllocatedMax = 0;
  reservationAccUnitTypeCheckOutDate = null as string | null;
  reservationAccUnitTypeCheckOutTime = null as string | null;
  propertyCheckOutTime = null as string | null;
  guests: ReservationCheckInCustomerData[] = [];
  isDayStay = false;

  get checkedIn() {
    return this.guests.filter(x => x.isCheckedIn || x.isDirty).length;
  }

  displayName() {
    return `${this.propertyName}, ${this.accomodationUnitTypeName}, ${this.accomodationUnitName}`;
  }

  displayCount() {
    const allocated = this.reservationAccUnitTypeAllocated;
    return `(${this.checkedIn}/${allocated}, max ${this.reservationAccUnitTypeAllocatedMax})`;
  }

  isOverTheAllocated() {
    const allocated = this.reservationAccUnitTypeAllocated;
    return this.checkedIn > allocated;
  }
}

export class ServerReservationCheckInCustomerData {
  id = 0;
  guestId = 0;

  isReservationHolder = false;

  firstName = "";
  middleName = "";
  lastName = "";
  genderId = 1;
  eMail = "";
  telephoneNumber = "";
  city: string | null = null;
  streetName: string | null = null;
  houseNumber: string | null = null;
  countryOfResidenceId: number | null = null;
  countryOfBirthId: number | null = null;
  citizenshipId: number | null = null;
  dateOfBirth: string | null = "";
  identificationDocumentNumber = "";
  identificationDocumentTypeId: number | null = null;

  checkInDate: string | null = "";
  checkOutDate: string | null = "";
  eVisitorId: string | null = null;
  eVisitorFacilityPropertyId: number | null = null;
  eVisitorFacilityId: number | null = null;
  eVisitorPaymentCategoryId: number | null = null;
  eVisitorArrivalOrganizationTypeId: number | null = null;
  eVisitorCheckInDate: string | null = null;
  eVisitorCheckInTime: string | null = null;
  eVisitorExpectedCheckoutDate: string | null = null;
  eVisitorExpectedCheckoutTime: string | null = null;
  eVisitorCheckoutDate: string | null = null;
  eVisitorCheckoutTime: string | null = null;
  arrivalReasonId: number | null = null;

  isCheckedIn = false;
  isCheckedOut = false;

  eVisitorIsCheckedIn = false;
  eVisitorIsCheckedOut = false;

  reservationPropertyId: number | null = null;
  reservationId: number | null = null;
  accomodationUnitId: number | null = null;

  eVisitorCheckOutDateViewField: string | null = null;
  eVisitorCheckOutTimeViewField: string | null = null;
}

export class ReservationCheckInCustomerData extends ServerReservationCheckInCustomerData {
  hasScanIssues = false;
  isDirty = false;
  isEmpty = true;

  eVisitorCheckinResult: {
    success: boolean;
    message: string;
  } | null = null;

  getEffectiveEVisitorPaymentCategoryId(eVisitorIntegrationId: number) {
    if (this.eVisitorPaymentCategoryId) {
      return this.eVisitorPaymentCategoryId;
    }

    let effective = null as null | number;

    if (eVisitorIntegrationId === EVisitorIntegrationEnum.HR) {
      if (this.dateOfBirth) {
        const age = DateTime.local().diff(
          DateTime.fromISO(this.dateOfBirth),
          "years"
        ).years;
        if (age <= 12) {
          effective = eVisitorCityTaxPaymentCategoriesEnum.DijeteDo12;
        } else if (age <= 18) {
          effective = eVisitorCityTaxPaymentCategoriesEnum.Dijete12Do18;
        } else {
          effective = eVisitorCityTaxPaymentCategoriesEnum.Turist;
        }
      }
    }
    else if (eVisitorIntegrationId === EVisitorIntegrationEnum.SL) {
      if (this.dateOfBirth) {
        const age = DateTime.local().diff(
          DateTime.fromISO(this.dateOfBirth),
          "years"
        ).years;
        if (age <= 7) {
          effective = eVisitorCityTaxPaymentCategoriesEnum.Exemption_ChildUpTo7_SL_eTurizem;
        } else if (age <= 18) {
          effective = eVisitorCityTaxPaymentCategoriesEnum.HalfPayment_PersonAged7To18_SL_eTurizem;
        } else {
          effective = eVisitorCityTaxPaymentCategoriesEnum.FullPayment_NoException_SL_eTurizem;
        }
      }
    }

    return effective;
  }
}

export interface EVisitorGuestsViewModel {
  firstName: string;
  middleName: string;
  lastName: string;
  reservationId: number;
  accommodationUnitName: string;
  accommodationUnitTypeName: string;
  propertyName: string;
  arrivalDate: string | null;
  arrivalTime: string | null;
  departureDate: string | null;
  departureTime: string | null;
  eVisitorPaymentCategoryId: number | null;
  eVisitorArrivalOrganizationTypeId: number | null;
}

export enum eVisitorArrivalOrganizationTypesEnum {
  Osobno = 1,
  GrupnoAgencijski = 2
}

export enum CheckStatusEnum {
  Neprijavljen = 1,
  Prijavljen = 2,
  Odjavljen = 3
}

export enum eVisitorCityTaxPaymentCategoriesEnum {
  Turist = 1,
  Dijete12Do18 = 2,
  DijeteDo12 = 3,
  VlasnikKuce = 4,
  SkolskiPaket = 5,
  Daci = 6,
  OsobeDo29IYHF = 7,
  TuristCharter = 8,
  PratiteljInvalida = 9,
  PutniciNaBrodu = 10,
  Studenti = 11,
  SezonskiRadnici = 12,
  Lokalac = 13,
  Invalid = 14,
  SocijalnaSkrb = 15,
  OsobeVlasnikaKuce = 16,
  TuristUKuciStanovikaGrada = 17,
  OwnerOfOriginalOldFamilyHouse_HR_eVisitor = 18,

  // SL eTurizem
  FullPayment_NoException_SL_eTurizem = 19,
  Exemption_ChildUpTo7_SL_eTurizem = 20,
  Exemption_MedicalReferral_SL_eTurizem = 21,
  Exemption_PhysicalDisabiltiy_SL_eTurizem = 22,
  Exemption_ChildWithSpecialNeeds_SL_eTurizem = 23,
  Exemption_EducationalProgram_SL_eTurizem = 24,
  Exemption_Students_SL_eTurizem = 25,
  PartialPayment_TemporaryWorkers_SL_eTurizem = 26,
  Exemption_InternationalAgreement_SL_eTurizem = 27,
  Exemption_MountainLodge_PZSMembers_SL_eTurizem = 28,
  Exemption_MunicipalRegulation_SL_eTurizem = 29,
  HalfPayment_PersonAged7To18_SL_eTurizem = 30,
  HalfPayment_IYHF_YouthAccommodation_Aged18To30_SL_eTurizem = 31,
  HalfPayment_CampingTourist_SL_eTurizem = 32,
  HalfPayment_MunicipalRegulation_SL_eTurizem = 33,
  PartialPayment_MunicipalRegulation_SL_eTurizem = 34,
  NoPayment_NoOvernightService_SL_eTurizem = 35,
  Exemption_ParticipantsOfVacationsThroughPublicInterestAssociations_SL_eTurizem = 36,
  Exemption_VolunteersForTheEliminationOfNaturalDisasters_SL_eTurizem = 37,
  Exemption_PoliceOfficersDuringThePeriodOfPerformanceOfDuties_SL_eTurizem = 38
}
